import { STORE_CARD_DESCRIPTION_ELLIPSIS } from '@/lib/constants';

/**
 * Binary-search truncate so `fullText` + ellipsis fits within `el.clientHeight`.
 * Mutates `el.textContent` while measuring; returns the string to render (always ends with "..." when truncated).
 */
export function truncateTextToFitElement(
  el: HTMLElement,
  fullText: string,
  ellipsis: string = STORE_CARD_DESCRIPTION_ELLIPSIS,
): string {
  const text = fullText.trim();
  if (!text) return '';

  el.textContent = text;
  if (el.scrollHeight <= el.clientHeight + 1) return text;

  let lo = 0;
  let hi = text.length;
  let best = ellipsis;

  while (lo <= hi) {
    const mid = Math.floor((lo + hi) / 2);
    const candidate = mid <= 0 ? ellipsis : `${text.slice(0, mid).trimEnd()}${ellipsis}`;
    el.textContent = candidate;
    if (el.scrollHeight <= el.clientHeight + 1) {
      best = candidate;
      lo = mid + 1;
    } else {
      hi = mid - 1;
    }
  }

  return best;
}
